/* global MatgenGlobal, $ */

import hotkeys from 'hotkeys-js';
//import { v4 as UUID } from 'uuid';
//import { FabricObjectDefaults } from '../../vars.js';
import { UI } from '../ui/ui.js';

const keys = [
  'esc',
  '↩︎',
  'ctrl+c',
  'command+c',
  'ctrl+shift+b',
  'command+shift+b',
  'ctrl+shift+f',
  'command+shift+f',
  'ctrl+shift+l',
  'command+shift+l',
  'ctrl+shift+r',
  'command+shift+r',
  'ctrl+shift+c',
  'command+shift+c',
  'ctrl+v',
  'command+v',
  'ctrl+x',
  'command+x',
  'ctrl+s',
  'command+s',
  'ctrl+g',
  'command+g',
  'ctrl+shift+g',
  'command+shift+g',
  'ctrl+i',
  'command+i',
  'ctrl+o',
  'command+o',
  'ctrl+shift+0',
  'command+shift+0',
  'ctrl+r',
  'command+r',
  'ctrl+z',
  'command+z',
  'ctrl+y',
  'command+y',
  'ctrl+shift+z',
  'command+shift+z',
  'up',
  'down',
  'left',
  'right',
  'shift+up',
  'shift+down',
  'shift+left',
  'shift+right',
  'alt+up',
  'alt+down',
  'alt+left',
  'alt+right',
  'del',
  'delete',
  'backspace',
];

function handleAlignment(activeObject, type) {
  const groupWidth = activeObject.width;
  //const groupHeight = activeObject.getHeight();

  const objs = activeObject.getObjects();

  for (let i = 0; i < objs.length; i++) {
    const itemWidth = objs[i].getBoundingRect().width;
    //const itemHeight = objs[i].getBoundingRect().height;

    switch (type) {
      default:
        break;
      case 'left':
        objs[i].set({
          left: -(groupWidth / 2),
          originX: 'left',
        });
        break;
      case 'center':
        objs[i].set({
          left: 0 - itemWidth / 2,
          originX: 'left',
        });
        break;
      case 'right':
        objs[i].set({
          left: groupWidth / 2 - itemWidth / 2,
          originX: 'center',
        });
        break;
    }
    objs[i].setCoords();
    MatgenGlobal.editor.cur().fabric.renderAll();
  }
  MatgenGlobal.editor
    .cur()
    .fabric.discardActiveObject()
    .renderAll();
}

function isTypingInControl(target) {
  return (
    target &&
    (target.isContentEditable ||
      target.closest('input, textarea, select, [contenteditable="true"]'))
  );
}

function getNudgeStep(event) {
  const configuredStep = Number.parseFloat(MatgenGlobal.NUDGE_STEP);
  const step =
    Number.isFinite(configuredStep) && configuredStep > 0 ? configuredStep : 1;

  // Alt always gives authors a one-pixel adjustment, even when the grid's
  // configured nudge size is larger. Shift makes repeated moves faster.
  if (event.altKey) {
    return 1;
  }
  return event.shiftKey ? step * 10 : step;
}

function nudgeActiveObject(canvas, activeObject, direction, event) {
  if (!activeObject || activeObject.isEditing) {
    return false;
  }

  const step = getNudgeStep(event);
  const horizontal = direction === 'left' || direction === 'right';
  const movementLocked = horizontal
    ? activeObject.lockMovementX
    : activeObject.lockMovementY;
  if (movementLocked) {
    return false;
  }

  if (direction === 'up') {
    activeObject.top -= step;
  } else if (direction === 'down') {
    activeObject.top += step;
  } else if (direction === 'left') {
    activeObject.left -= step;
  } else if (direction === 'right') {
    activeObject.left += step;
  }

  activeObject.setCoords();
  canvas.fabric.requestRenderAll();
  canvas.recordHistoryState();
  return true;
}

const init = () => {
  //console.log('INIT KEY EVENTS');
  hotkeys(keys.join(','), (event, handler) => {
    // Keep native typing, navigation, and clipboard interactions working in
    // forms and editable layer names.
    if (isTypingInControl(event.target)) {
      return;
    }

    const arrowKey = handler.key.split('+').pop();
    if (['up', 'down', 'left', 'right'].includes(arrowKey)) {
      let canvas, activeObject;
      if (MatgenGlobal.editor) {
        canvas = MatgenGlobal.editor.cur();
        activeObject = canvas && canvas.fabric.getActiveObject();
      }
      if (nudgeActiveObject(canvas, activeObject, arrowKey, event)) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    let canvas, activeObject;
    if (MatgenGlobal.editor) {
      canvas = MatgenGlobal.editor.cur();
      activeObject = canvas.fabric.getActiveObject();
    }

    //let group;
    //const cids = [];
    //const badGroup = false;

    switch (handler.key) {
      case 'esc':
        /*delete MatgenGlobal.drawing;
        delete MatgenGlobal.polygonMode;
        delete MatgenGlobal.pointArray;
        delete MatgenGlobal.lineArray;
        delete MatgenGlobal.activeLine;*/
        console.log('you pressed esc!');
        break;
      case '↩︎':
        console.log('you pressed enter!');
        break;
      case 'ctrl+c':
      case 'command+c':
        if (activeObject) {
          canvas.copy();
        } else {
          console.error('No item selected');
        }
        break;
      case 'ctrl+shift+b':
      case 'command+shift+b':
        if (activeObject) {
          canvas.fabric.sendBackwards(activeObject);
          canvas.fabric.requestRenderAll();
          UI.canvasChanged();
        } else {
          console.error('No item selected');
        }
        break;
      case 'ctrl+shift+f':
      case 'command+shift+f':
        if (activeObject) {
          canvas.fabric.bringForward(activeObject);
          canvas.fabric.requestRenderAll();
          UI.canvasChanged();
        } else {
          console.error('No item selected');
        }
        break;
      case 'ctrl+shift+l':
      case 'command+shift+l':
        if (activeObject) {
          handleAlignment(activeObject, 'left');
          canvas.recordHistoryState();
        }
        break;
      case 'ctrl+shift+c':
      case 'command+shift+c':
        if (activeObject) {
          handleAlignment(activeObject, 'center');
          canvas.recordHistoryState();
        }
        break;
      case 'ctrl+shift+r':
      case 'command+shift+r':
        if (activeObject) {
          handleAlignment(activeObject, 'right');
          canvas.recordHistoryState();
        }
        break;
      case 'ctrl+v':
      case 'command+v':
        if (canvas && canvas.clipboard) {
          canvas.paste();
        } else {
          console.error('Nothing copied yet');
        }
        break;
      /*case 'del':
      case 'delete':
      case 'backspace':
        if (activeObject) {
          canvas.fabric.remove(activeObject);
          canvas.fabric.requestRenderAll();
          UI.canvasChanged();
        } else {
          console.error('No item selected');
        }
        break;
      case 'ctrl+x':
      case 'command+x':
        if (activeObject) {
          canvas.copy();
          canvas.fabric.remove(activeObject);
          canvas.fabric.requestRenderAll();
          UI.canvasChanged();
        } else {
          console.error('No item selected');
        }
        break;*/
      case 'ctrl+s':
      case 'command+s':
        $('#template-save, #material-save, #extra-save-button')
          .filter(':visible')
          .first()
          .trigger('click');
        break;
      case 'ctrl+g':
      case 'command+g':
        UI.group(activeObject);
        break;
      case 'ctrl+shift+g':
      case 'command+shift+g':
        if (!activeObject) {
          console.error('No item selected');
          return;
        }
        if (activeObject.type == 'group') {
          MatgenGlobal.editor.groupComponentId = activeObject.componentId;
          MatgenGlobal.editor.groupId = activeObject.id;

          const items = activeObject._objects;
          activeObject._restoreObjectsState();
          canvas.fabric.remove(activeObject);
          for (let i = 0; i < items.length; i++) {
            delete items[i].groupId;
            if (activeObject.currentOptionId) {
              items[i].currentOptionId = activeObject.currentOptionId;
            }
            canvas.fabric.add(items[i]);
            canvas.fabric.item(canvas.fabric.size() - 1).hasControls = true;
          }

          canvas.fabric.requestRenderAll();
          UI.canvasChanged(activeObject.componentId);
        }

        break;
      case 'ctrl+i':
      case 'command+i':
        MatgenGlobal.editor.cur().zoom();
        break;
      case 'ctrl+o':
      case 'command+o':
        MatgenGlobal.editor.cur().zoom(true);
        break;
      case 'ctrl+shift+0':
      case 'command+shift+0':
        MatgenGlobal.editor.resetZoom();
        break;
      /*case 'ctrl+r':
      case 'command+r':
        console.log('you pressed ctrl+r!');
        break;*/
      case 'ctrl+z':
      case 'command+z':
        canvas.undo();
        break;
      case 'ctrl+y':
      case 'command+y':
      case 'ctrl+shift+z':
      case 'command+shift+z':
        canvas.redo();
        break;
      /*case 'ctrl+z':
      case 'command+z':
        console.log('UNDO');
        canvas.fabric.undo();
        canvas.fabric.renderAll();
        break;
      case 'ctrl+y':
      case 'command+y':
        console.log('REDO');
        canvas.fabric.redo();
        canvas.fabric.renderAll();
        break;*/
      //return false;
      default:
        console.log(event);
    }
  });
};

export { init };
